import { ServiceType } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { ServiceTimeClass } from '@mews/enums';
import { getTimeClass } from '@mews-commander/utils';
import { useCurrentService } from '../../queries/useCurrentService';
import { PricingSection } from './sections/PricingSection';
import { TaxSection } from './sections/TaxSection';
import { PostingSection } from './sections/PostingSection';
import { WithDisabledPricingFields } from './sections/types';

export const PricingStepFields = ({ disabled }: WithDisabledPricingFields) => {
    const service = useCurrentService();
    return (
        <Stack spacing="400" vertical>
            {service.data.discriminator === ServiceType.Bookable ? <PricingSection disabled={disabled} /> : null}
            <TaxSection />
            {service.data.discriminator === ServiceType.Bookable ? (
                <PostingSection
                    bookableServiceData={service.data.value}
                    serviceTimeClass={getTimeClass(service) || ServiceTimeClass.Night}
                    disabled={disabled}
                />
            ) : null}
        </Stack>
    );
};
